import React from 'react';
import { Badge } from '@/components/ui/Badge';

interface CorrectiveActionCardProps {
  title: string;
  description: string;
  category: string;
  priority: 'CRITIQUE' | 'HAUTE' | 'MOYENNE' | 'BASSE';
  difficulty: 'FACILE' | 'MOYEN' | 'DIFFICILE';
  estimatedCost?: number;
}

export const CorrectiveActionCard: React.FC<CorrectiveActionCardProps> = ({
  title,
  description,
  category,
  priority,
  difficulty,
  estimatedCost
}) => {
  // Get category label and badge
  const getCategoryBadge = () => {
    const label = category === 'DPE_CORRECTION' ? 'Correction DPE' : 'Équipement';
    return <Badge variant="outline" size="sm">{label}</Badge>;
  };

  // Get priority badge
  const getPriorityBadge = () => {
    switch (priority) {
      case 'CRITIQUE':
        return <Badge variant="danger" size="sm">Priorité critique</Badge>;
      case 'HAUTE':
        return <Badge variant="warning" size="sm">Priorité haute</Badge>;
      case 'MOYENNE':
        return <Badge variant="info" size="sm">Priorité moyenne</Badge>;
      case 'BASSE':
        return <Badge variant="default" size="sm">Priorité basse</Badge>;
      default:
        return <Badge variant="default" size="sm">Priorité</Badge>;
    }
  };

  // Get difficulty badge
  const getDifficultyBadge = () => {
    switch (difficulty) {
      case 'FACILE':
        return <Badge variant="success" size="sm">Difficulté facile</Badge>;
      case 'MOYEN':
        return <Badge variant="warning" size="sm">Difficulté moyenne</Badge>;
      case 'DIFFICILE':
        return <Badge variant="danger" size="sm">Difficulté élevée</Badge>;
      default:
        return <Badge variant="default" size="sm">Difficulté</Badge>;
    }
  };

  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-white hover:shadow-sm transition-shadow">
      <div className="space-y-3">
        {/* Title */}
        <h4 className="font-semibold text-gray-900">{title}</h4>

        {/* Description */}
        <p className="text-sm text-gray-700">{description}</p>

        {/* Badges */}
        <div className="flex flex-wrap items-center gap-2">
          {getCategoryBadge()}
          {getPriorityBadge()}
          {getDifficultyBadge()}
        </div>
      </div>
    </div>
  );
};

export default CorrectiveActionCard;
